import React from "react";
import { Button, ConfigProvider, Empty, Input, Modal } from "antd";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import { Card } from "react-bootstrap";

const WatiTemplatesModal = ({ allTemplateData, setAllTemplateData }) => {


    const search_quickresponses = (event) => {
        var value = event?.target?.value;
        var temp = allTemplateData?.templates?.filter((data) => {
            return (
                data?.name?.toLowerCase()?.includes(value?.toLowerCase()) ||
                data?.text?.toLowerCase()?.includes(value?.toLowerCase())
            );
        });
        setAllTemplateData(prev => ({ ...prev, templates_temp: temp }))
    };

    const handleFinalViewOpen = (chosenTemplateID) => {
        const chosenTemplateOut = allTemplateData?.templates_temp?.find(e => e?.id == chosenTemplateID)?.text;
        setAllTemplateData(prev => ({
            ...prev,
            chosenTemplateID,
            finalViewOpen: true,
            chosenTemplateOut: chosenTemplateOut
        }))
    }

    const handleCloseQuickReplies = () => {
        setAllTemplateData({ open: false, record: null, templates: null, templates_temp: null, chosenTemplateID: null, chosenTemplateOut: null, finalViewOpen: false, priceValues: null })
    }

    return (
        <>
            {/* wati templates showing main modal */}
            <Modal
                open={allTemplateData?.open}
                onCancel={handleCloseQuickReplies}
                centered
                maskClosable={false}
                title={
                    <div className="p-2">{`Use a Quick Response For Query ID : ${allTemplateData?.record?.query_id} (${allTemplateData?.record?.cus_name} - ${allTemplateData?.record?.phone})`}</div>
                }
                width={950}
                footer={
                    <div className="flex justify-left ml-2" style={{ fontSize: "12px" }}>
                        <i>*Most used templates are shown first</i>
                    </div>
                }
            >
                <div className="p-2 m-2 rounded border drop-shadow" style={{ backgroundColor: "#f7f7f7" }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <Input
                            allowClear
                            placeholder="Filter Templates"
                            size="large"
                            className="mb-2"
                            onChange={search_quickresponses}
                        />
                    </div>
                    <div>
                        <div
                            style={{
                                fontSize: "12px",
                                color: "gray",
                                justifyContent: "flex-start",
                                display: "flex",
                                position: "sticky",
                            }}
                        >
                            <em>
                                Total <b>{allTemplateData?.templates_temp?.length || 0}</b> templates.
                            </em>
                        </div>
                    </div>
                    <div
                        className="flex border rounded p-2 m-2 flex-wrap justify-center drop-shadow-1"
                        style={{ maxHeight: "396px", overflowY: "auto", backgroundColor: "#dce0df" }}
                    >
                        {allTemplateData?.templates_temp?.length > 0 ? allTemplateData?.templates_temp?.map((element, index) => (
                            <Card
                                className="m-2"
                                style={{
                                    width: "48%",
                                    height: "173px",
                                    overflowY: "auto",
                                    backgroundColor: "#d2d9d7",
                                }}
                                key={index}
                            >
                                <div
                                    className="flex justify-center"
                                    style={{
                                        fontSize: "12px",
                                        color: "#666",
                                        position: "sticky",
                                        backgroundColor: "white",
                                        zIndex: 10
                                    }}
                                >
                                    <i>
                                        Template has been used <b>{element.triggered}</b> times.
                                    </i>
                                </div>
                                <Card.Body>
                                    <Card.Title
                                        className="flex justify-between"
                                    >
                                        <div style={{ fontWeight: "550" }}>
                                            {element.name}
                                        </div>
                                        <ConfigProvider
                                            theme={{
                                                components: {
                                                    Button: {
                                                        defaultHoverColor: "#ffffff",
                                                        defaultHoverBg: "#3be368",
                                                        defaultBg: "#ffffff",
                                                    },
                                                },
                                            }}
                                        >
                                            <Button
                                                size='middle'
                                                className="mr-2"
                                                onClick={() => handleFinalViewOpen(element.id)}
                                            >
                                                <SendOutlinedIcon />
                                            </Button>
                                        </ConfigProvider>
                                    </Card.Title>
                                    <Card.Text
                                        className="border rounded p-2"
                                        style={{ overflowY: "auto", height: "80px", backgroundColor: "#fbfbfb" }}>{element.text}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        )) : (<Empty />)}
                    </div>
                </div>
            </Modal >

        </>

    );
}

export default WatiTemplatesModal;